import { HttpErrorResponse } from "@angular/common/http";

export class ApiError {

    public message: string = "";
    public status: string = "";
    public timestamp: string = "";
    public httpStatus: number;

    constructor(public error: HttpErrorResponse){
        if(error.error){
        this.message = error.error.message;
        this.status = error.error.status;
        this.timestamp = error.error.timestamp;
        }
        this.httpStatus = error.status;
    }
}
